import { Avatar, Popover, Typography } from 'antd';
import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import BotAvatar from '../../../../../../assets/customSVG/inbox/webchat/BotAvatar';
import { useSelector } from 'react-redux';
import { getRandomColorsBassedOnLetters } from '../../../../../../helper/colors';

const { Text } = Typography;

const MessageAvatar = ({ className, avatarType = '', size = 35, message }) => {
  avatarType = avatarType.toUpperCase();
  return (
    <div className={`flex flex-col justify-center items-center ${className}`}>
      {avatarType === 'END_USER' ? (
        <Avatar icon={<UserOutlined />} size={size} />
      ) : avatarType === 'SYSTEM_USER' ? (
        <RenderSystemUser size={size} message={message} />
      ) : avatarType === 'AGENT' ? (
        <div className="border-[1px] border-black rounded-full p-1">
          <BotAvatar />
        </div>
      ) : (
        <Avatar icon={<UserOutlined />} size={size} />
      )}
    </div>
  );
};

export default MessageAvatar;

const RenderSystemUser = ({ message }) => {
  const { teamMembers } = useSelector((state) => state.inbox);
  const member = teamMembers.find(
    (member) => member.team_member_id == message?.team_member_id,
  );
  const { color } = getRandomColorsBassedOnLetters(
    member?.screen_name?.slice(0, 1).toUpperCase(),
  );

  return (
    <Popover
      content={
        <Text className="text-xs text-gray-500">
          {member?.screen_name || 'User Name'}
        </Text>
      }
    >
      <Avatar
        src={member?.profile_photo}
        style={{
          backgroundColor: color,
        }}
      >
        {member?.screen_name?.slice(0, 1).toUpperCase()}
      </Avatar>
    </Popover>
  );
};
